import { useSuspenseCurrentMedication } from '@/hooks/useCurrentMedication'
import { isLinkMedRequest, isMpsMedRequest, isMultiProductOrderMedRequest } from '@/lib/utils'
import MultiProductOrderPrescriptionDetails from './multi-product-order/prescription-details'
import LinkPrescriptionDetails from './link-prescription-details'
import MpsPrescriptionDetails from './mps-prescription-details'
import PrescriptionDetailsStandard from './prescription-details-standard'

/**
 * Picks the layout by order type. Every layout renders the `prescription-details` id/test id, which
 * the nav menu and the e2e suite target.
 */
export default function PrescriptionDetails({ isEditable }: { isEditable: boolean }) {
  const { data: medRequestData } = useSuspenseCurrentMedication()

  if (isMultiProductOrderMedRequest(medRequestData)) {
    return <MultiProductOrderPrescriptionDetails isEditable={isEditable} />
  }

  if (isMpsMedRequest(medRequestData)) {
    return <MpsPrescriptionDetails isEditable={isEditable} />
  }

  if (isLinkMedRequest(medRequestData)) {
    return <LinkPrescriptionDetails isEditable={isEditable} />
  }

  return <PrescriptionDetailsStandard isEditable={isEditable} />
}
